"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.evaluateValue = evaluateValue;
exports.resolvePath = resolvePath;
exports.pushInterpretation = pushInterpretation;
exports.pushTag = pushTag;
exports.getUniqueInterpretations = getUniqueInterpretations;
exports.getUniqueTags = getUniqueTags;
exports.isDirectTag = isDirectTag;
exports.isLogItemWithPath = isLogItemWithPath;
exports.isLogItemWithValue = isLogItemWithValue;
const provider_1 = require("./provider");
async function evaluateValue(rootCtx, ctx, value) {
    return (0, provider_1.isProvider)(value)
        ? (await value.evaluate({ rootCtx, ctx }))[1]
        : value;
}
function resolvePath(pathA, pathB) {
    if (pathB[0] === "") {
        return resolveAbsolutePath(pathB);
    }
    else {
        return resolveRelativePath(pathA, pathB);
    }
}
function resolveAbsolutePath(path) {
    return path.slice(1);
}
function resolveRelativePath(pathA, pathB) {
    const pathC = [...pathA];
    for (const key of pathB) {
        if (key === "..") {
            if (pathC.length === 0) {
                throw new Error("invalid relative path");
            }
            pathC.pop();
        }
        else {
            pathC.push(key);
        }
    }
    return pathC;
}
function pushInterpretation({ interpretations = [] }, interpretation) {
    return { interpretations: [...interpretations, interpretation] };
}
function pushTag({ tags = [] }, tag) {
    return { tags: [...tags, tag] };
}
function getUniqueInterpretations(items) {
    const map = new Map();
    for (const item of items) {
        map.set(`${item.vocab}-${item.code}`, item);
    }
    return Array.from(map.values());
}
function getUniqueTags(items) {
    const map = new Map();
    for (const item of items) {
        map.set(`${item.source || "direct"}-${item.vocab}-${item.code}`, item);
    }
    return Array.from(map.values());
}
function isDirectTag(tag) {
    return tag.source === undefined;
}
function isLogItemWithPath(item) {
    return "path" in item;
}
function isLogItemWithValue(item) {
    return "value" in item;
}
